module.exports = "img/icon_context_person.034a4b2.svg";